<template>
  <div
    :class="[
      'section',
      expandable ? 'section--expandable' : '',
      expanded ? 'section--expanded' : '',
      hideIcon ? 'hide-icon' : '',
    ]"
  >
    <div v-if="title" class="title" @click="expandable ? toggleSection() : null">
      <div class="name h4">{{ title }}</div>
      <div v-if="!expandable || expanded" class="column-name h5">
        {{ columnName }}
      </div>
      <div v-if="expandable" class="icon">{{ iconContent }}</div>
    </div>
    <div class="section__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    toggleAll: {
      from: 'toggleAll', // this is optional if using the same key for injection
      default: null,
    },
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    columnName: {
      type: String,
      required: false,
      default: '',
    },
    expandable: {
      type: Boolean,
      default: false,
    },
    expandOnLoad: {
      type: Boolean,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      expanded: this.expandOnLoad,
    }
  },
  computed: {
    toggleAllValue() {
      return this.toggleAll?.value
    },
    iconContent() {
      return this.expanded ? '-' : '+'
    },
  },
  watch: {
    toggleAllValue(value) {
      this.toggleSection(value)
    },
  },
  methods: {
    toggleSection(open = null) {
      this.expanded = open === null ? !this.expanded : open
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  position: relative;

  .name {
    flex: 1 1 auto;
    font-weight: 700;
    line-height: normal;
  }

  .icon {
    flex: 0 0 auto;
    display: flex;
    background-color: $color-primary;
    color: $white;
    font-size: 1rem;
    width: 35px;
    height: 35px;
    justify-content: center;
    align-items: center;
  }

  .column-name {
    padding-right: 1.5rem;
    line-height: normal;
    font-weight: 700;
    flex: 0 0 auto;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  &--expandable {
    .title {
      &:hover {
        cursor: pointer;
      }

      .icon {
        &:hover {
          background-color: $color-primary-dark;
        }
      }
    }

    &.hide-icon {
      .icon {
        display: none;
      }
    }

    .section__content {
      display: none;
    }
  }

  &--expanded {
    .section__content {
      display: block;
    }
  }
}

.title {
  line-height: normal;
  position: sticky;
  top: -0.6em;
  z-index: 9;
  background: #fff;
  margin-bottom: 0.5em;
  border-bottom: 1px solid $gray-light;
  padding: 0.25em 0 0.5em;
  box-shadow: $shadow-focus-ring;
}
</style>
